import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { ADD_QUOTATION, API_BOOK } from 'src/@core/services/util/api.endpoints';
import { AppService } from 'src/@core/services/app.service';
import { AccountService } from 'src/@core/services/account.service';
import { CURRENT_EMPLOYER } from 'src/@core/services/app.service';
import { environment } from 'src/environments/environment';
import { EmployementPaymentOrder } from 'src/@core/interfaces/employment/employement-payment-order.model';
import { EmployeerPaymentOrderService } from 'src/@core/services/employment/employment-payment-order.service';
import { Router } from '@angular/router';
import { NotificationService } from 'src/@core/services/notification.service';
import { roles } from 'src/app/shared/helpers/roles-permissions';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import { FormArray, FormControl } from '@angular/forms';

@Component({
  selector: 'hour4u-admin-request-quote',
  templateUrl: './request-quote.component.html',
  styleUrls: ['./request-quote.component.scss']
})
export class RequestQuoteComponent implements OnInit {
  society: any;
  bookingDate: any;
  numberOfHours: any;
  totalExpectedAmount: any;
  profile = this.appService.getCurrentAccount();
  isButtonDisabled: boolean = false;
  isLoading: boolean = false;
  services: any[] = [];
  selectedServicesArray: any[] = [];
  selectedServices: any = null;
  currentUserRole: any = null;
  roles = roles;
  selectedFileNames: string[] = [];
  attachmentsArray: any[] = [];
  additionalInfo: any = null;
  servicesListArray: FormArray;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RequestQuoteComponent>,
    private http: HttpClient,
    private appService: AppService,
    private router: Router,
    private notify: NotificationService,
    private employerUploadService: EmployerUploadService
  ) { }

  ngOnInit() {
    console.log(this.data)
    this.services = this.data.enquiry.services;
    this.currentUserRole = this.data.currentUserRole;

    console.log(this.services)
    if (this.services && this.services.length) {
      let selectedServices = [];
      this.selectedServicesArray = [];
      this.services.forEach(ele => {
        let obj = {
          "name": ele,
          "rate": null
        }
        selectedServices.push(obj);
      })
      this.selectedServicesArray = selectedServices;
      this.selectedServices = selectedServices.join(", ");
    }
  }

  quoteSend() {
    this.isButtonDisabled = true;
    this.isLoading = true;
    // let serviceAmounts = [];
    let gstAmount = 0;
    let totalAmount = 0;
    let totalBilling = 0;
    this.selectedServicesArray.forEach((ele, index) => {
      // serviceAmounts.push({ da: ele.rate })
      totalBilling = totalBilling + ele.rate;
    })
    gstAmount = totalBilling * 0.18;
    totalAmount = totalBilling + gstAmount;
    let obj = {
      "gstAmount": gstAmount,
      "services": this.selectedServicesArray,
      "totalAmount": totalAmount,
      "totalBilling": totalBilling
    }
    console.log(obj)
    if (totalAmount && totalAmount > 0 && totalBilling && totalBilling > 0) {
      this.http.post(ADD_QUOTATION + '/' + this.data.id, obj).subscribe(
        (response: any) => {
          this.isButtonDisabled = false;
          this.isLoading = false;
          this.notify.showMessage("Quotation sent Successfully!", 2000);
          this.closeDialog(true);
        }, (err => {
          this.isButtonDisabled = false;
          this.isLoading = false;
        }))
    } else {
      this.isButtonDisabled = false;
      this.isLoading = false;
      this.notify.showMessage("Please enter valid rate of services!", 2000);
    }
  }

  closeDialog(isRefresh?: boolean) {
    this.dialogRef.close(isRefresh);
  }

  // get Total Billing
  getTotalBilling() {
    let totalBilling = 0;
    this.selectedServicesArray.forEach(ele => {
      totalBilling = totalBilling + ele.rate;
    })
    return totalBilling;
  }

  // applicable GST
  applicableGST() {
    let totalBilling = 0;
    this.selectedServicesArray.forEach(ele => {
      totalBilling = totalBilling + ele.rate;
    })

    totalBilling = totalBilling * 0.18
    return totalBilling;
  }

  // get Total Final Billing
  getTotalFinalBilling() {
    let totalBilling = 0;
    this.selectedServicesArray.forEach(ele => {
      totalBilling = totalBilling + ele.rate;
    })

    totalBilling = totalBilling * 1.18
    return totalBilling;
  }
}
